<template>
  <div>
    <div class="custom-card">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="picture-upload-form text-center">
              <div class="my-3">
                <image-uploader :imageUrl="organization.imageurl" @input="handleImageUpload($event)"
                  @remove-image="removeImage" :isUploadingImage="isUploadingImage" />
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-12 col-12">
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="fname" class="label">Organization Name</label>
                <input type="text" class="input" v-model="organization.companyname"
                  placeholder="-- Enter First Name --" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="mname" class="label">Organization Type</label>
                <el-select filterable v-model="organization.type" placeholder="Select">
                  <el-option v-for="type in organizationTypes" :key="type" :label="type" :value="type">
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="lastname" class="label">Specialization</label>
                <el-select filterable v-model="organization.specialization" placeholder="Select"
                  :disabled="!filteredSpecializations.length">
                  <el-option v-for="specialization in filteredSpecializations" :key="specialization"
                    :label="specialization" :value="specialization">
                  </el-option>
                </el-select>
              </div>
              <div hidden class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Specialization</label>
                <input type="email" v-model="organization.customdomain" class="input" disabled />
              </div>
            </div>
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="gender" class="label">Business Coverage</label>
                <el-select filterable v-model="organization.industry" placeholder="Select"
                  @change="removeSelectedSpecialization">
                  <el-option v-for="industry in industries" :key="industry" :label="industry" :value="industry">
                  </el-option>
                </el-select>
              </div>

              <div hidden class="new-user-form__single-input-wrapper">
                <label for="lastname" class="label">Specializations</label>
                <el-select filterable v-model="organization.specialization" placeholder="Select"
                  :disabled="!filteredSpecializations.length">
                  <el-option v-for="specialization in filteredSpecializations" :key="specialization"
                    :label="specialization" :value="specialization">
                  </el-option>
                </el-select>
              </div>

              <div class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Domain Name</label>
                <!-- <input type="email" v-model="organization.businessCoverage" class="input" disabled /> -->
                 <div class="domain-cover flex">
                  <input type="text" placeholder="https://muleEX.com/" class="input muleEX" disabled />
                  <!-- <div>https://muleEX.com/</div> -->
                  <input type="text" v-model="organization.companyname" class="input"  placeholder="-- Enter --" disabled />
                 </div>
                
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Email Address</label>
                <input type="email" disabled class="input" v-model="organization.email" />
              </div>
            </div>
            <div class="input-row">
              
              <div class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Phone Number</label>
                <vue-tel-input :preferredCountries="['Nigeria']" v-model="organization.mobile_no"></vue-tel-input>
              </div>
              <div class="new-user-form__single-input-wrapper"></div>
              <div class="new-user-form__single-input-wrapper"></div>
            </div>
          </div>
        </div>
      </div>
      <hr />
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <h3>Contact Adddress</h3>
          </div>

          <div class="col-md-12 col-lg-12 col-12">
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="fname" class="label">Address</label>
                <vue-google-autocomplete id="map2" ref="shipperAddress" :value="location.address" classname="input"
                  placeholder="Enter address" v-on:placechanged="getAddress">
                </vue-google-autocomplete>
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="mname" class="label">Country</label>
                <input type="text" class="input" v-model="location.country" />
              </div>
              <div class="new-user-form__single-input-wrapper">
                <label for="gender" class="label">State</label>
                <input type="text" class="input" v-model="location.state" />
              </div>
            </div>
            <div class="input-row">
              <div class="new-user-form__single-input-wrapper">
                <label for="lname" class="label">City</label>

                <input type="text" class="input" v-model="location.city" />
              </div>

              <div hidden class="new-user-form__single-input-wrapper">
                <label for="email" class="label">Timezone</label>
                <el-select v-model="organization.orgTimezone" placeholder="Select" filterable>
                  <el-option v-for="timezone in timezones" :key="timezone" :label="timezone" :value="timezone">
                  </el-option>
                </el-select>
              </div>

              <div hidden class="new-user-form__single-input-wrapper">
                <label for="number" class="label">Language</label>
                <el-select v-model="organization.language" placeholder="Select">
                  <el-option v-for="language in languages" :key="language" :label="language" :value="language">
                  </el-option>
                </el-select>
              </div>
              <div class="new-user-form__single-input-wrapper"></div>
              <div class="new-user-form__single-input-wrapper"></div>

            </div>
          </div>

        </div>
      </div>
      <!-- <hr />
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <h3>Social Pages</h3>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="fname" class="label">Facebook</label>
              <div class="d-flex modal-input">
                <span
                  ><img src="@/assets/images/icons/facebook.svg" alt=""
                /></span>
                <input
                  type="text"
                  class="input"
                  v-model="organization.facebook"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="fname" class="label">Instagram</label>
              <div class="d-flex modal-input">
                <span
                  ><img src="@/assets/images/icons/instagram.svg" alt=""
                /></span>
                <input
                  type="text"
                  class="input"
                  v-model="organization.instagram"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="fname" class="label">LinkedIn</label>
              <div class="d-flex modal-input">
                <span
                  ><img src="@/assets/images/icons/linkedin.svg" alt=""
                /></span>
                <input
                  type="text"
                  class="input"
                  v-model="organization.linkedin"
                />
              </div>
            </div>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <div class="new-user-form__single-input-wrapper">
              <label for="fname" class="label">Twitter</label>
              <div class="d-flex modal-input">
                <span
                  ><img src="@/assets/images/icons/twitter.svg" alt=""
                /></span>
                <input
                  type="text"
                  class="input"
                  v-model="organization.twitter"
                />
              </div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="flex items-center my-4 justify-between">
        <div class="cursor-pointer" @click="$router.go(-1)">
          <p>Cancel</p>
        </div>
        <base-button text="Save" @click="updateOrganization" :loading="updatingOrganization" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  organizationTypes,
  industries,
  specializations,
} from "@/utilities/globalVariables";
import ImageUploader from "@/components/3pl/Users/ImageUploader";
import timezones from "@/utilities/timezones";
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: { ImageUploader, VueGoogleAutocomplete },
  data() {
    return {
      isUploadingImage: false,
      updatingOrganization: false,
      selected: null,
      options: ["Option 1", "Option 2", "Option 3"],
      organizationTypes: organizationTypes,
      industries: industries,
      specializations: specializations,
      location: {
        locationName: "",
        type: "",
        address: "",
        country: "",
        state: "",
        city: "",
      },
      organization: {
        id: "",
        companyname: "",
        type: "",
        country: "",
        stateId: "",
        city: "",
        industry: "",
        specialization: "",
        mobile_no: "",
        customdomain: "",
        regnumber: "",
        email: "",
        web: "",
        facebook: "",
        instagram: "",
        linkedin: "",
        twitter: "",
        language: "",
        orgTimezone: "",
      },
      states: [],
      countries: ["Nigeria"],
      selectedIndustry: "",
      cities: [],
      timezones: timezones,
      languages: ["English"],
      user: {},
      orgLocation: {},
    };
  },
  computed: {
    filteredSpecializations() {
      let indexOfSelectedIndustry = this.industries.indexOf(
        this.organization.industry
      );
      if (indexOfSelectedIndustry >= 0) {
        return this.specializations[indexOfSelectedIndustry];
      } else {
        return [];
      }
    },
    geoCoderPayload() {
      return {
        lat: null,
        long: null,
      };
    },
  },
  mounted() {
    this.findUserDetails();

    this.getAllStates();

    this.user = JSON.parse(localStorage.getItem("loggedInUser"));

    const organization = JSON.parse(
      localStorage.getItem("organizationDetails")
    );

    this.selectedIndustry = this.organization.industry;
    this.organization.id = organization.id;
    this.organization.companyname = organization.companyname;
    this.organization.type = organization.type;
    this.organization.customdomain = organization.customdomain;
    this.organization.regnumber = organization.regnumber;
    this.organization.address = organization.address;
    this.organization.country = organization.country;
    this.organization.stateId = organization.stateId;
    this.organization.city = organization.city;
    this.organization.email = organization.email;
    this.organization.industry = organization.industry;
    this.organization.specialization = organization.specialization;
    this.organization.mobile_no = organization.mobile_no;
    this.organization.imageurl = organization.imageurl;
    this.organization.web = organization.web;
    this.organization.facebook = organization.facebook;
    this.organization.instagram = organization.instagram;
    this.organization.linkedin = organization.linkedin;
    this.organization.twitter = organization.twitter;
    (this.organization.language = organization.language),
      (this.organization.orgTimezone = organization.orgTimezone);
  },
  watch: {
    "location.state"(val) {
      this.cities = [];
      if (val?.length > 0) {
        this.cities = [
          ...this.states.find((state) => state.name == val).cities,
        ];

        console.log(this.cities);
      }
    },
    location: {
      deep: true,
      immediate: true,
      handler(val) {
        if (val.long) {
          this.geoCoderPayload.long = val.long;
        }
        if (val.lat) {
          this.geoCoderPayload.lat = val.lat;
        }
        if (this.geoCoderPayload.lat && this.geoCoderPayload.long) {
          this.getGeoCoder();
        }
      },
    },
  },
  methods: {
    async getGeoCoder() {
      try {
        const response = await this.$_getStateNameWithDim(this.geoCoderPayload);
        console.log(JSON.stringify(response.data, null, 2));
        let geoData = response.data;
        this.location.state = geoData.state;
        this.location.city = geoData.address.city;
        this.location.country = geoData.address.country;
        // this.assignCountryAndState(response.data);
      } catch (error) {
        this.handleError();
      }
    },
    async updateOrganization() {
      this.updatingOrganization = true;
      this.organization.orgId = localStorage.getItem("organizationId");

      let payload = {
        org: {
          id: this.organization.id,
          companyname: this.organization.companyname,
          regnumber: this.organization.regnumber,
          web: this.organization.web,
          industry: this.organization.industry,
          specialization: this.organization.specialization,
          facebook: this.organization.facebook,
          linkedin: this.organization.linkedin,
          twitter: this.organization.twitter,
          instagram: this.organization.instagram,
          type: this.organization.type,
          language: this.organization.language,
          orgTimezone: this.organization.orgTimezone,
          mobile_no: this.organization.mobile_no,
        },
        location: this.location,
      };

      try {
        let response = await this.$_updateOrganizationInformation(payload);

        localStorage.removeItem("organizationDetails");
        localStorage.setItem(
          "organizationDetails",
          JSON.stringify(response.data.data.org)
        );
        this.generateToast(
          "Organization Details successfully updated!",
          "success"
        );
        this.updatingOrganization = false;
        this.$router.push({ name: "AccountProfile" });
      } catch (error) {
        this.handleError(error);
        this.updatingOrganization = false;
      }
    },
    async handleImageUpload(image) {
      this.isUploadingImage = true;
      try {
        let response = await this.uploadImage(image);
        this.organization.imageurl = response;
        this.isUploadingImage = false;
        this.generateToast("Image uploaded", "success");
      } catch (error) {
        this.handleError(error);
        this.isUploadingImage = false;
      }
    },
    async getAllStates() {
      try {
        let response = await this.$_getAllStatesAndCities();
        this.states = response.data.data;
      } catch (error) {
        this.handleError(error);
      }
    },
    getAddress(addressData) {
      this.location.address = addressData.route;
      this.location.lat = addressData.latitude;
      this.location.long = addressData.longitude;
    },
    async findUserDetails() {
      try {
        let response = await this.$_findUserDetails();
        this.location = response.data.data.Org.locations[0];
      } catch (error) {
        this.handleError(error);
        this.loading = false;
      }
    },

    removeSelectedSpecialization() {
      this.organization.specialization = "";
    },
    removeImage() {
      this.organization.imageurl = null;
    },
    returnPayload() {
      return this.organization;
    },
  },
};
</script>

<style lang="scss" scoped>
.muleEX::placeholder{
  font-size: 12px;
  font-weight: 400;
  color: rgba(245, 244, 250, 1);
}
.muleEX{
  background-color: rgba(56, 63, 81, 1);
}
.domain-cover{
  gap: 1%;
}
.picture-upload-form {
  border-radius: 10px;
  padding: 1.55rem 1rem;
}
.picture-upload-form__img-wrapper {
  position: relative;
}
.user-img {
  width: 10rem;
  margin: 1.5rem auto;
}
.upload-img-icon {
  position: absolute;
  right: 3.5rem;
  bottom: 1rem;
}
.picture-upload-form__meta {
  padding-top: 1rem;
}
.label {
  font-size: 0.9rem;
}
.input {
  margin-bottom: 0.5rem;
}
.new-user-form__col-three {
  padding-top: 1.25rem;
}
hr {
  margin: 2rem 0;
}

.input-row {
  width: 100%;
  display: flex;
}
.input-row > div {
  width: 100%;
  padding-right: 1rem;
}

.modal-input {
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  height: 2.75rem;
  border-radius: 4px;
  display: flex;

  input {
    border: none;
    background: transparent;
  }
  span {
    align-self: center;
    padding: 0 0.5rem;
    color: #747474;
    cursor: pointer;
  }
}
@media screen and (max-width: 768px) {
  .input-row {
    flex-direction: column;
  }
  .input-row div {
    width: 100%;
  }
}
</style>
